import * as React from 'react';
import CtaButton from './CtaButton';
import Icon from './Icon';

export default function ImageBanner(props) {
  const {
    title,
    html,
    cta = '',
    url = '',
    target = '_blank',
    image,
    links = []
  } = props;

  const inlineStyles = {
    '--nv-banner-mobile-image': `url(${image.mobile_image})`,
    '--nv-banner-tablet-image': `url(${image.tablet_image})`,
    '--nv-banner-laptop-image': `url(${image.laptop_image})`,
    '--nv-banner-desktop-image': `url(${image.desktop_image})`,
  };

  return (
    <div className='nv-banner__inner' style={inlineStyles}>
      <div className="hero-image flex-shrink-0">
        <div className="container h-100">
          <div className="row h-100">
            <div className="col col-md-6">
              <div className="hero-lockup">
                <h1 className="h--medium mb-2" dangerouslySetInnerHTML={{__html: title}}></h1>
                <div dangerouslySetInnerHTML={{__html: html}}></div>
                <CtaButton text={cta} url={url} target={target}/>
              </div>
            </div>
            {links.length > 0 && (
                <div className='col col-12 d-flex justify-content-center'>
                  <div className="nv-banner__icons">
                    {links.length > 0 && links.map(link => {
                      return (
                          <Icon
                              key={link.url}
                              url={link.url}
                              platform={link.platform}
                              target='_blank'
                          />
                      );
                    })}
                  </div>
                </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
